const ROOT = ".js-guide-tabs";
const PANELS = ".guide__panels";
const TAB = '[role="tab"]';
const PANEL = '[role="tabpanel"]';

export const guideTabs = () => {
  document.querySelectorAll(ROOT).forEach((root) => {
    const tabs = Array.from(root.querySelectorAll(TAB));
    const panels = Array.from(root.querySelectorAll(PANEL));
    const panelsWrap = root.querySelector(PANELS);
    if (!tabs.length || tabs.length !== panels.length || !panelsWrap) return;

    const syncPanelsHeight = () => {
      const active = panels.find((p) => p.classList.contains("is-active"));
      if (!active) return;
      panelsWrap.style.height = `${active.scrollHeight}px`;
    };

    const activate = (index) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle("is-active", on);
        tab.setAttribute("aria-selected", on ? "true" : "false");
        tab.setAttribute("tabindex", on ? "0" : "-1");
      });
      panels.forEach((panel, i) => {
        const on = i === index;
        panel.classList.toggle("is-active", on);
        panel.setAttribute("aria-hidden", on ? "false" : "true");
      });
      requestAnimationFrame(() => {
        syncPanelsHeight();
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(index));
    });

    const onResize = () => syncPanelsHeight();
    window.addEventListener("resize", onResize);

    const ro = new ResizeObserver(() => syncPanelsHeight());
    panels.forEach((p) => ro.observe(p));

    syncPanelsHeight();
  });
};
